// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Overlay background */
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  background: rgba(15, 18, 25, 0.55);
  backdrop-filter: blur(3px);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: authFadeIn .15s ease-out;
}

@keyframes authFadeIn {
  from { opacity: 0; }
  to { opacity: 1; }
}

/* Full-page variant for standalone destinations (email verification, password
   reset) — .overlay is a translucent dark scrim meant to dim page content
   sitting behind it; these pages have nothing behind them, so that scrim
   alone reads as a near-black void. This is a solid, on-brand background instead. */
.auth-standalone {
  position: fixed;
  inset: 0;
  background: #f8fafc;
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 9999;
  animation: authFadeIn .15s ease-out;
}

@keyframes authRiseIn {
  from { opacity: 0; transform: translateY(8px) scale(.98); }
  to { opacity: 1; transform: translateY(0) scale(1); }
}

/* Modal box */
.modal {
  display: flex;
  flex-direction: column;
  padding: 32px 32px 28px;
  background: #fff;
  width: 400px;
  max-width: calc(100vw - 32px);
  border-radius: 18px;
  position: relative;
  box-shadow: 0 24px 60px rgba(15, 23, 42, .28), 0 4px 14px rgba(15, 23, 42, .1);
  font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Helvetica, Arial, sans-serif;
  animation: authRiseIn .18s cubic-bezier(.16,1,.3,1);
}

/* Close button (X) */
.close-btn {
  position: absolute;
  top: 14px;
  right: 14px;
  width: 28px;
  height: 28px;
  border: none;
  background: #f1f5f9;
  border-radius: 8px;
  cursor: pointer;
  color: #64748b;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background .12s, color .12s;
}
.close-btn:hover {
  background: #e2e8f0;
  color: #111827;
}

/* Header: logo + brand + title */
.auth-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  margin-bottom: 20px;
}

.auth-logo {
  width: 44px;
  height: 44px;
  border-radius: 13px;
  background: linear-gradient(135deg, #3b82f6, #1d4ed8);
  color: #fff;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 6px 16px rgba(37, 99, 235, .35);
  margin-bottom: 10px;
}

.auth-brand {
  font-size: 11px;
  font-weight: 700;
  letter-spacing: .08em;
  text-transform: uppercase;
  color: #94a3b8;
  margin-bottom: 14px;
}

.auth-title {
  font-size: 20px;
  font-weight: 700;
  color: #111827;
  margin: 0 0 5px;
  letter-spacing: -.01em;
}

.auth-subtitle {
  font-size: 13px;
  color: #6b7280;
  margin: 0;
  line-height: 1.5;
}

/* Login / Register segmented tabs */
.auth-tabs {
  display: flex;
  gap: 3px;
  background: #f1f5f9;
  padding: 3px;
  border-radius: 10px;
  margin-bottom: 18px;
}

.auth-tab {
  flex: 1 1;
  border: none;
  background: transparent;
  padding: 8px 0;
  border-radius: 8px;
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
  cursor: pointer;
  transition: background .12s, color .12s;
  font-family: inherit;
}

.auth-tab.active {
  background: #fff;
  color: #111827;
  box-shadow: 0 1px 3px rgba(0,0,0,.1);
}

/* Fields */
.auth-field {
  margin-bottom: 14px;
  text-align: left;
}

.auth-label-row {
  display: flex;
  align-items: center;
  justify-content: space-between;
  margin-bottom: 6px;
}

.auth-label {
  display: block;
  font-size: 11.5px;
  font-weight: 700;
  color: #374151;
  margin-bottom: 6px;
  letter-spacing: .01em;
}

.auth-label-row .auth-label { margin-bottom: 0; }

.auth-input {
  width: 100%;
  padding: 10px 13px;
  border-radius: 10px;
  border: 1px solid #d1d5db;
  font-size: 13.5px;
  font-family: inherit;
  color: #111827;
  outline: none;
  box-sizing: border-box;
  background: #fff;
  transition: border-color .12s, box-shadow .12s;
}

.auth-input::placeholder { color: #9ca3af; }

.auth-input:focus {
  border-color: #2563eb;
  box-shadow: 0 0 0 3px rgba(37, 99, 235, .12);
}

/* Buttons */
.auth-submit {
  width: 100%;
  padding: 11px;
  border: none;
  border-radius: 10px;
  background: #2563eb;
  color: #fff;
  font-size: 13.5px;
  font-weight: 700;
  cursor: pointer;
  font-family: inherit;
  transition: background .12s, transform .05s;
  margin-top: 4px;
  box-shadow: 0 2px 8px rgba(37, 99, 235, .28);
}

.auth-submit:hover:not(:disabled) { background: #1d4ed8; }
.auth-submit:active:not(:disabled) { transform: translateY(1px); }

.auth-submit:disabled {
  background: #cbd5e1;
  cursor: not-allowed;
  box-shadow: none;
}

.auth-secondary {
  width: 100%;
  padding: 10px;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  background: #fff;
  color: #374151;
  font-size: 13px;
  font-weight: 600;
  cursor: pointer;
  font-family: inherit;
  margin-top: 8px;
  transition: background .12s;
}

.auth-secondary:hover { background: #f8fafc; }

.auth-switch {
  text-align: center;
  font-size: 12.5px;
  color: #6b7280;
  margin-top: 14px;
}

.auth-link-inline {
  background: none;
  border: none;
  color: #2563eb;
  font-weight: 700;
  font-size: inherit;
  cursor: pointer;
  padding: 0;
  font-family: inherit;
}

.auth-link-inline:hover { text-decoration: underline; }

/* Divider */
.auth-divider {
  display: flex;
  align-items: center;
  text-align: center;
  color: #9ca3af;
  font-size: 11.5px;
  margin: 18px 0 14px;
}

.auth-divider::before,
.auth-divider::after {
  content: "";
  flex: 1 1;
  height: 1px;
  background: #eef0f3;
}

.auth-divider span {
  padding: 0 10px;
  white-space: nowrap;
}

.auth-google {
  display: flex;
  justify-content: center;
}
`, "",{"version":3,"sources":["webpack://./src/components/UserAuth/UserAuth.css"],"names":[],"mappings":"AAAA,uBAAuB;AACvB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,YAAY;EACZ,aAAa;EACb,kCAAkC;EAClC,0BAA0B;EAC1B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,OAAO,UAAU,EAAE;EACnB,KAAK,UAAU,EAAE;AACnB;;AAEA;;;oFAGoF;AACpF;EACE,eAAe;EACf,QAAQ;EACR,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,mCAAmC;AACrC;;AAEA;EACE,OAAO,UAAU,EAAE,qCAAqC,EAAE;EAC1D,KAAK,UAAU,EAAE,iCAAiC,EAAE;AACtD;;AAEA,cAAc;AACd;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,gBAAgB;EAChB,YAAY;EACZ,6BAA6B;EAC7B,mBAAmB;EACnB,kBAAkB;EAClB,8EAA8E;EAC9E,gGAAgG;EAChG,mDAAmD;AACrD;;AAEA,qBAAqB;AACrB;EACE,kBAAkB;EAClB,SAAS;EACT,WAAW;EACX,WAAW;EACX,YAAY;EACZ,YAAY;EACZ,mBAAmB;EACnB,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uCAAuC;AACzC;AACA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,iCAAiC;AACjC;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,qDAAqD;EACrD,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,6CAA6C;EAC7C,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,SAAS;EACT,gBAAgB;AAClB;;AAEA,oCAAoC;AACpC;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;EACvB,cAAc;EACd,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,uCAAuC;EACvC,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,cAAc;EACd,oCAAoC;AACtC;;AAEA,WAAW;AACX;EACE,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,kBAAkB;EAClB,qBAAqB;AACvB;;AAEA,8BAA8B,gBAAgB,EAAE;;AAEhD;EACE,WAAW;EACX,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,iBAAiB;EACjB,oBAAoB;EACpB,cAAc;EACd,aAAa;EACb,sBAAsB;EACtB,gBAAgB;EAChB,8CAA8C;AAChD;;AAEA,2BAA2B,cAAc,EAAE;;AAE3C;EACE,qBAAqB;EACrB,4CAA4C;AAC9C;;AAEA,YAAY;AACZ;EACE,WAAW;EACX,aAAa;EACb,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,2CAA2C;EAC3C,eAAe;EACf,4CAA4C;AAC9C;;AAEA,oCAAoC,mBAAmB,EAAE;AACzD,qCAAqC,0BAA0B,EAAE;;AAEjE;EACE,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,aAAa;EACb,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,eAAe;EACf,2BAA2B;AAC7B;;AAEA,wBAAwB,mBAAmB,EAAE;;AAE7C;EACE,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,cAAc;EACd,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;EACf,UAAU;EACV,oBAAoB;AACtB;;AAEA,0BAA0B,0BAA0B,EAAE;;AAEtD,YAAY;AACZ;EACE,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,cAAc;EACd,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;;EAEE,WAAW;EACX,SAAO;EACP,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;AACzB","sourcesContent":["/* Overlay background */\n.overlay {\n  position: fixed;\n  top: 0;\n  left: 0;\n  width: 100vw;\n  height: 100vh;\n  background: rgba(15, 18, 25, 0.55);\n  backdrop-filter: blur(3px);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  animation: authFadeIn .15s ease-out;\n}\n\n@keyframes authFadeIn {\n  from { opacity: 0; }\n  to { opacity: 1; }\n}\n\n/* Full-page variant for standalone destinations (email verification, password\n   reset) — .overlay is a translucent dark scrim meant to dim page content\n   sitting behind it; these pages have nothing behind them, so that scrim\n   alone reads as a near-black void. This is a solid, on-brand background instead. */\n.auth-standalone {\n  position: fixed;\n  inset: 0;\n  background: #f8fafc;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 9999;\n  animation: authFadeIn .15s ease-out;\n}\n\n@keyframes authRiseIn {\n  from { opacity: 0; transform: translateY(8px) scale(.98); }\n  to { opacity: 1; transform: translateY(0) scale(1); }\n}\n\n/* Modal box */\n.modal {\n  display: flex;\n  flex-direction: column;\n  padding: 32px 32px 28px;\n  background: #fff;\n  width: 400px;\n  max-width: calc(100vw - 32px);\n  border-radius: 18px;\n  position: relative;\n  box-shadow: 0 24px 60px rgba(15, 23, 42, .28), 0 4px 14px rgba(15, 23, 42, .1);\n  font-family: -apple-system, BlinkMacSystemFont, \"Segoe UI\", Roboto, Helvetica, Arial, sans-serif;\n  animation: authRiseIn .18s cubic-bezier(.16,1,.3,1);\n}\n\n/* Close button (X) */\n.close-btn {\n  position: absolute;\n  top: 14px;\n  right: 14px;\n  width: 28px;\n  height: 28px;\n  border: none;\n  background: #f1f5f9;\n  border-radius: 8px;\n  cursor: pointer;\n  color: #64748b;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  transition: background .12s, color .12s;\n}\n.close-btn:hover {\n  background: #e2e8f0;\n  color: #111827;\n}\n\n/* Header: logo + brand + title */\n.auth-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  margin-bottom: 20px;\n}\n\n.auth-logo {\n  width: 44px;\n  height: 44px;\n  border-radius: 13px;\n  background: linear-gradient(135deg, #3b82f6, #1d4ed8);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 6px 16px rgba(37, 99, 235, .35);\n  margin-bottom: 10px;\n}\n\n.auth-brand {\n  font-size: 11px;\n  font-weight: 700;\n  letter-spacing: .08em;\n  text-transform: uppercase;\n  color: #94a3b8;\n  margin-bottom: 14px;\n}\n\n.auth-title {\n  font-size: 20px;\n  font-weight: 700;\n  color: #111827;\n  margin: 0 0 5px;\n  letter-spacing: -.01em;\n}\n\n.auth-subtitle {\n  font-size: 13px;\n  color: #6b7280;\n  margin: 0;\n  line-height: 1.5;\n}\n\n/* Login / Register segmented tabs */\n.auth-tabs {\n  display: flex;\n  gap: 3px;\n  background: #f1f5f9;\n  padding: 3px;\n  border-radius: 10px;\n  margin-bottom: 18px;\n}\n\n.auth-tab {\n  flex: 1;\n  border: none;\n  background: transparent;\n  padding: 8px 0;\n  border-radius: 8px;\n  font-size: 13px;\n  font-weight: 600;\n  color: #64748b;\n  cursor: pointer;\n  transition: background .12s, color .12s;\n  font-family: inherit;\n}\n\n.auth-tab.active {\n  background: #fff;\n  color: #111827;\n  box-shadow: 0 1px 3px rgba(0,0,0,.1);\n}\n\n/* Fields */\n.auth-field {\n  margin-bottom: 14px;\n  text-align: left;\n}\n\n.auth-label-row {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  margin-bottom: 6px;\n}\n\n.auth-label {\n  display: block;\n  font-size: 11.5px;\n  font-weight: 700;\n  color: #374151;\n  margin-bottom: 6px;\n  letter-spacing: .01em;\n}\n\n.auth-label-row .auth-label { margin-bottom: 0; }\n\n.auth-input {\n  width: 100%;\n  padding: 10px 13px;\n  border-radius: 10px;\n  border: 1px solid #d1d5db;\n  font-size: 13.5px;\n  font-family: inherit;\n  color: #111827;\n  outline: none;\n  box-sizing: border-box;\n  background: #fff;\n  transition: border-color .12s, box-shadow .12s;\n}\n\n.auth-input::placeholder { color: #9ca3af; }\n\n.auth-input:focus {\n  border-color: #2563eb;\n  box-shadow: 0 0 0 3px rgba(37, 99, 235, .12);\n}\n\n/* Buttons */\n.auth-submit {\n  width: 100%;\n  padding: 11px;\n  border: none;\n  border-radius: 10px;\n  background: #2563eb;\n  color: #fff;\n  font-size: 13.5px;\n  font-weight: 700;\n  cursor: pointer;\n  font-family: inherit;\n  transition: background .12s, transform .05s;\n  margin-top: 4px;\n  box-shadow: 0 2px 8px rgba(37, 99, 235, .28);\n}\n\n.auth-submit:hover:not(:disabled) { background: #1d4ed8; }\n.auth-submit:active:not(:disabled) { transform: translateY(1px); }\n\n.auth-submit:disabled {\n  background: #cbd5e1;\n  cursor: not-allowed;\n  box-shadow: none;\n}\n\n.auth-secondary {\n  width: 100%;\n  padding: 10px;\n  border: 1px solid #e2e8f0;\n  border-radius: 10px;\n  background: #fff;\n  color: #374151;\n  font-size: 13px;\n  font-weight: 600;\n  cursor: pointer;\n  font-family: inherit;\n  margin-top: 8px;\n  transition: background .12s;\n}\n\n.auth-secondary:hover { background: #f8fafc; }\n\n.auth-switch {\n  text-align: center;\n  font-size: 12.5px;\n  color: #6b7280;\n  margin-top: 14px;\n}\n\n.auth-link-inline {\n  background: none;\n  border: none;\n  color: #2563eb;\n  font-weight: 700;\n  font-size: inherit;\n  cursor: pointer;\n  padding: 0;\n  font-family: inherit;\n}\n\n.auth-link-inline:hover { text-decoration: underline; }\n\n/* Divider */\n.auth-divider {\n  display: flex;\n  align-items: center;\n  text-align: center;\n  color: #9ca3af;\n  font-size: 11.5px;\n  margin: 18px 0 14px;\n}\n\n.auth-divider::before,\n.auth-divider::after {\n  content: \"\";\n  flex: 1;\n  height: 1px;\n  background: #eef0f3;\n}\n\n.auth-divider span {\n  padding: 0 10px;\n  white-space: nowrap;\n}\n\n.auth-google {\n  display: flex;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
